// @ts-ignore
/* eslint-disable */
import { request as umiRequest } from '@umijs/max';

/**
 * 封装后的 request
 * @param url 接口地址
 * @param opts 请求参数
 * @returns 直接返回后端返回体中的 data 字段
 */
const request = async <T>(url: string, opts: any = { method: 'GET' }): Promise<T> => {
  const response = await umiRequest<{ data: T }>(url, {
    ...opts,
  });
  // 2. 直接返回 data 字段
  // 如果执行到这一步，说明 errorThrower 没有抛出错误
  return response.data as T;
};


/** 获取当前的用户 GET /api/currentUser */
export async function currentUser(id: number, options?: { [key: string]: any }) {
  return request<API.CurrentUser>('/api/users/' + id, {
    method: 'GET',
    ...(options || {}),
  });
}

/** 退出登录接口 POST /api/login/outLogin */
export async function outLogin(options?: { [key: string]: any }) {
  return request<Record<string, any>>('/api/logout', {
    method: 'POST',
    ...(options || {}),
  });
}

/** 注册接口 POST /api/register */
export async function register(body: API.RegisterParams, options?: { [key: string]: any }) {
  return request<API.LoginResult>('/api/users', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    data: body,
    ...(options || {}),
  });
}

/** 登录接口 POST /api/login/account */
export async function login(body: API.LoginParams, options?: { [key: string]: any }) {
  const res = await request<API.LoginResult>('/api/login', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    data: {
      username: body.username,
      password: body.password,
    },
    ...(options || {}),
  });
  // console.log("login: " + JSON.stringify(res));

  console.log("get login: " + JSON.stringify(res));

  return res;
}

/** 此处后端没有提供注释 GET /api/notices */
export async function getNotices(options?: { [key: string]: any }) {
  return request<API.NoticeIconList>('/api/notices', {
    method: 'GET',
    ...(options || {}),
  });
}

/** 获取规则列表 GET /api/rule */
export async function rule(
  params: {
    // query
    /** 当前的页码 */
    current?: number;
    /** 页面的容量 */
    pageSize?: number;
  },
  options?: { [key: string]: any },
) {
  return request<API.RuleList>('/api/rule', {
    method: 'GET',
    params: {
      ...params,
    },
    ...(options || {}),
  });
}

/** 更新规则 PUT /api/rule */
export async function updateRule(options?: { [key: string]: any }) {
  return request<API.RuleListItem>('/api/rule', {
    method: 'POST',
    data: {
      method: 'update',
      ...(options || {}),
    },
  });
}

/** 新建规则 POST /api/rule */
export async function addRule(options?: { [key: string]: any }) {
  return request<API.RuleListItem>('/api/rule', {
    method: 'POST',
    data: {
      method: 'post',
      ...(options || {}),
    },
  });
}

/** 删除规则 DELETE /api/rule */
export async function removeRule(options?: { [key: string]: any }) {
  return request<Record<string, any>>('/api/rule', {
    method: 'POST',
    data: {
      method: 'delete',
      ...(options || {}),
    },
  });
}


/** 获取工作流列表 GET /api/workflows */
export async function workflows(
  params: {
    // query
    /** 当前的页码 */
    current?: number;
    /** 页面的容量 */
    pageSize?: number;
  },
  options?: { [key: string]: any },
) {

  type T = {
    items?: API.Workflow[];
    total?: number;
  }

  const res = await request<T>('/api/workflows', {
    method: 'GET',
    params: {
      ...params,
    },
    ...(options || {}),
  });

  return {
    data: res.items,
    success: true,
    total: res.total,
  }
}

/** 获取工作流实例列表 GET /api/workflows */
export async function workflowInstances(
  params: {
    // query
    /** 当前的页码 */
    current?: number;
    /** 页面的容量 */
    pageSize?: number;
  },
  options?: { [key: string]: any },
) {

  type T = {
    items?: API.WorkflowInstance[];
    total?: number;
  }
  const res = await request<T>('/api/instances', {
    method: 'GET',
    params: {
      ...params,
    },
    ...(options || {}),
  });

  return {
    data: res.items,
    success: true,
    total: res.total,
  }
}

export async function addWorkflowInstance(ins: any, options?: { [key: string]: any },
) {
  return request<API.WorkflowInstanceList>('/api/instances', {
    method: 'POST',
    data: ins,
    ...(options || {}),
  });
}

export async function removeWorkflowInstance(id: number, options?: { [key: string]: any },
) {
  return request('/api/instances/' + id, {
    method: 'DELETE',
    ...(options || {}),
  });
}

export async function updateWorkflowInstanceStatus(id: number, status: string, data: any, options?: { [key: string]: any }) {
  return request<API.RuleListItem>('/api/instances/' + id + '/status', {
    method: 'PUT',
    data: {
      status: status,
      data: data,
    },
    ...(options || {}),
  });
}


export async function updateWorkflowInstanceETA(id: number, stageCode: string, time: string, reason ?: string, options?: { [key: string]: any }) {
  return request<API.ETAList>('/api/instances/' + id + '/stages/' + stageCode + '/eta', {
    method: 'PUT',
    data: {
      time: time,
      reason: reason,
    },
    ...(options || {}),
  });
}